export default "__VITE_ASSET__DDj8A3wC__"